import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { showToast } from '../../../../../../../../utils/toast';
import { updateRole } from '../../../../api';
import { IRoleManageForm } from '../../../../types/Roles';

export const useActionRoleManageEditForm = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const updateAdminRole = useCallback(
    async (roleId: number, values: IRoleManageForm) => {
      const { data, error } = await updateRole(roleId, values);
      if (data) {
        showToast(false, t);
        history.push('/users-and-roles/roles');
      }
      if (error) {
        showToast(true, t);
      }
    },
    [t, history],
  );

  return {
    updateAdminRole,
  };
};
